import _extends from "@babel/runtime-corejs2/helpers/esm/extends";
import _classCallCheck from "@babel/runtime-corejs2/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime-corejs2/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime-corejs2/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs2/helpers/esm/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime-corejs2/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime-corejs2/helpers/esm/inherits";
import _defineProperty from "@babel/runtime-corejs2/helpers/esm/defineProperty";
import _Object$keys from "@babel/runtime-corejs2/core-js/object/keys";
import React, { Component } from "react";
import { shouldRender, parseDateString, toDateString, pad } from "../../utils";
function rangeOptions(start, stop) {
  var options = [];
  for (var i = start; i <= stop; i++) {
    options.push({
      value: i,
      label: pad(i, 2)
    });
  }
  return options;
}
function readyForChange(state) {
  return _Object$keys(state).every(function (key) {
    return state[key] !== -1;
  });
}
function DateElement(props) {
  var type = props.type,
    range = props.range,
    value = props.value,
    select = props.select,
    rootId = props.rootId,
    disabled = props.disabled,
    readonly = props.readonly,
    autofocus = props.autofocus,
    registry = props.registry,
    onBlur = props.onBlur;
  var id = rootId + "_" + type;
  var SelectWidget = registry.widgets.SelectWidget;
  return React.createElement(SelectWidget, {
    schema: {
      type: "integer"
    },
    id: id,
    className: "form-control",
    options: {
      enumOptions: rangeOptions(range[0], range[1])
    },
    placeholder: type,
    value: value,
    disabled: disabled,
    readonly: readonly,
    autofocus: autofocus,
    onChange: function onChange(value) {
      return select(type, value);
    },
    onBlur: onBlur
  });
}
var AltDateWidget = /*#__PURE__*/
function (_Component) {
  _inherits(AltDateWidget, _Component);
  function AltDateWidget(props) {
    var _this;
    _classCallCheck(this, AltDateWidget);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(AltDateWidget).call(this, props));
    _defineProperty(_assertThisInitialized(_this), "onChange", function (property, value) {
      _this.setState(_defineProperty({}, property, typeof value === "undefined" ? -1 : value), function () {
        // Only propagate to parent state if we have a complete date{time}
        if (readyForChange(_this.state)) {
          _this.props.onChange(toDateString(_this.state, _this.props.time));
        }
      });
    });
    _defineProperty(_assertThisInitialized(_this), "setNow", function (event) {
      event.preventDefault();
      var _this$props = _this.props,
        time = _this$props.time,
        disabled = _this$props.disabled,
        readonly = _this$props.readonly,
        onChange = _this$props.onChange;
      if (disabled || readonly) {
        return;
      }
      var nowDateObj = parseDateString(new Date().toJSON(), time);
      _this.setState(nowDateObj, function () {
        return onChange(toDateString(_this.state, time));
      });
    });
    _defineProperty(_assertThisInitialized(_this), "clear", function (event) {
      event.preventDefault();
      var _this$props2 = _this.props,
        time = _this$props2.time,
        disabled = _this$props2.disabled,
        readonly = _this$props2.readonly,
        onChange = _this$props2.onChange;
      if (disabled || readonly) {
        return;
      }
      _this.setState(parseDateString("", time), function () {
        return onChange(undefined);
      });
    });
    _this.state = parseDateString(props.value, props.time);
    return _this;
  }
  _createClass(AltDateWidget, [{
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      this.setState(parseDateString(nextProps.value, nextProps.time));
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState) {
      return shouldRender(this, nextProps, nextState);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props3 = this.props,
        id = _this$props3.id,
        disabled = _this$props3.disabled,
        readonly = _this$props3.readonly,
        autofocus = _this$props3.autofocus,
        registry = _this$props3.registry,
        onBlur = _this$props3.onBlur,
        options = _this$props3.options;
      return React.createElement("ul", {
        className: "list-inline"
      }, this.dateElementProps.map(function (elemProps, i) {
        return React.createElement("li", {
          key: i
        }, React.createElement(DateElement, _extends({
          rootId: id,
          select: _this2.onChange
        }, elemProps, {
          disabled: disabled,
          readonly: readonly,
          registry: registry,
          onBlur: onBlur,
          autofocus: autofocus && i === 0
        })));
      }), (options.hideNowButton !== "undefined" ? !options.hideNowButton : true) && React.createElement("li", null, React.createElement("a", {
        href: "#",
        className: "btn btn-info btn-now",
        onClick: this.setNow
      }, "Now")), (options.hideClearButton !== "undefined" ? !options.hideClearButton : true) && React.createElement("li", null, React.createElement("a", {
        href: "#",
        className: "btn btn-warning btn-clear",
        onClick: this.clear
      }, "Clear")));
    }
  }, {
    key: "dateElementProps",
    get: function get() {
      var _this$props4 = this.props,
        time = _this$props4.time,
        options = _this$props4.options;
      var _this$state = this.state,
        year = _this$state.year,
        month = _this$state.month,
        day = _this$state.day,
        hour = _this$state.hour,
        minute = _this$state.minute,
        second = _this$state.second;
      var data = [{
        type: "year",
        range: options.yearsRange,
        value: year
      }, {
        type: "month",
        range: [1, 12],
        value: month
      }, {
        type: "day",
        range: [1, 31],
        value: day
      }];
      if (time) {
        data.push({
          type: "hour",
          range: [0, 23],
          value: hour
        }, {
          type: "minute",
          range: [0, 59],
          value: minute
        }, {
          type: "second",
          range: [0, 59],
          value: second
        });
      }
      return data;
    }
  }]);
  return AltDateWidget;
}(Component);
_defineProperty(AltDateWidget, "defaultProps", {
  time: false,
  disabled: false,
  readonly: false,
  autofocus: false,
  options: {
    yearsRange: [1900, new Date().getFullYear() + 2]
  }
});
if (process.env.NODE_ENV !== "production") {}
export default AltDateWidget;